export default __webpack_public_path__ + "static/media/Violet the Painting Fairy.de273eca.jpeg";